// Verfahren-Finder regeln & metadata · DE/EN bilingual
// Single source of truth for the Fritz Kamm AG recommendation wizard.

const QUESTIONS = {
  de: [
    {
      id: "material",
      label: "Welches Material soll veredelt werden?",
      options: [
        { v: "Stahl" }, { v: "Aluminium" }, { v: "Messing" },
        { v: "Kupfer" }, { v: "Edelstahl" }, { v: "Anderes" },
      ],
    },
    {
      id: "goal",
      label: "Was ist Ihr Ziel?",
      options: [
        { v: "Korrosionsschutz" }, { v: "Bessere Optik" },
        { v: "Leitfähigkeit" }, { v: "Verschleißschutz" },
        { v: "Technischer Spezialzweck" },
      ],
    },
    {
      id: "quantity",
      label: "Welche Stückzahl?",
      options: [
        { v: "Einzelteil / Prototyp" }, { v: "Kleinserie" },
        { v: "Mittlere Serie" }, { v: "Großserie" },
      ],
    },
    {
      id: "timing",
      label: "Wann benötigen Sie die Lösung?",
      options: [
        { v: "Dringend" }, { v: "In den nächsten Wochen" }, { v: "In Planung" },
      ],
    },
  ],
  en: [
    {
      id: "material",
      label: "Which material needs to be finished?",
      options: [
        { v: "Stahl", l: "Steel" }, { v: "Aluminium", l: "Aluminium" },
        { v: "Messing", l: "Brass" }, { v: "Kupfer", l: "Copper" },
        { v: "Edelstahl", l: "Stainless steel" }, { v: "Anderes", l: "Other" },
      ],
    },
    {
      id: "goal",
      label: "What is your goal?",
      options: [
        { v: "Korrosionsschutz", l: "Corrosion protection" },
        { v: "Bessere Optik", l: "Better appearance" },
        { v: "Leitfähigkeit", l: "Electrical conductivity" },
        { v: "Verschleißschutz", l: "Wear protection" },
        { v: "Technischer Spezialzweck", l: "Special technical purpose" },
      ],
    },
    {
      id: "quantity",
      label: "What quantity?",
      options: [
        { v: "Einzelteil / Prototyp", l: "Single part / prototype" },
        { v: "Kleinserie", l: "Small series" },
        { v: "Mittlere Serie", l: "Medium series" },
        { v: "Großserie", l: "High volume" },
      ],
    },
    {
      id: "timing",
      label: "When do you need the solution?",
      options: [
        { v: "Dringend", l: "Urgent" },
        { v: "In den nächsten Wochen", l: "Within the next few weeks" },
        { v: "In Planung", l: "In planning" },
      ],
    },
  ],
  fr: [
    {
      id: "material",
      label: "Quel matériau souhaitez-vous traiter ?",
      options: [
        { v: "Stahl", l: "Acier" }, { v: "Aluminium", l: "Aluminium" },
        { v: "Messing", l: "Laiton" }, { v: "Kupfer", l: "Cuivre" },
        { v: "Edelstahl", l: "Acier inoxydable" }, { v: "Anderes", l: "Autre" },
      ],
    },
    {
      id: "goal",
      label: "Quel est votre objectif ?",
      options: [
        { v: "Korrosionsschutz", l: "Protection anti-corrosion" },
        { v: "Bessere Optik", l: "Meilleur aspect" },
        { v: "Leitfähigkeit", l: "Conductivité" },
        { v: "Verschleißschutz", l: "Protection contre l'usure" },
        { v: "Technischer Spezialzweck", l: "Usage technique spécifique" },
      ],
    },
    {
      id: "quantity",
      label: "Quelle quantité ?",
      options: [
        { v: "Einzelteil / Prototyp", l: "Pièce unique / prototype" },
        { v: "Kleinserie", l: "Petite série" },
        { v: "Mittlere Serie", l: "Série moyenne" },
        { v: "Großserie", l: "Grande série" },
      ],
    },
    {
      id: "timing",
      label: "Pour quand avez-vous besoin de la solution ?",
      options: [
        { v: "Dringend", l: "Urgent" },
        { v: "In den nächsten Wochen", l: "Dans les prochaines semaines" },
        { v: "In Planung", l: "En planification" },
      ],
    },
  ],
  it: [
    {
      id: "material",
      label: "Quale materiale desidera far trattare?",
      options: [
        { v: "Stahl", l: "Acciaio" }, { v: "Aluminium", l: "Alluminio" },
        { v: "Messing", l: "Ottone" }, { v: "Kupfer", l: "Rame" },
        { v: "Edelstahl", l: "Acciaio inox" }, { v: "Anderes", l: "Altro" },
      ],
    },
    {
      id: "goal",
      label: "Qual è il Suo obiettivo?",
      options: [
        { v: "Korrosionsschutz", l: "Protezione anticorrosiva" },
        { v: "Bessere Optik", l: "Aspetto migliore" },
        { v: "Leitfähigkeit", l: "Conduttività" },
        { v: "Verschleißschutz", l: "Protezione dall'usura" },
        { v: "Technischer Spezialzweck", l: "Scopo tecnico speciale" },
      ],
    },
    {
      id: "quantity",
      label: "Che quantità?",
      options: [
        { v: "Einzelteil / Prototyp", l: "Pezzo singolo / prototipo" },
        { v: "Kleinserie", l: "Piccola serie" },
        { v: "Mittlere Serie", l: "Media serie" },
        { v: "Großserie", l: "Grande serie" },
      ],
    },
    {
      id: "timing",
      label: "Quando Le serve la soluzione?",
      options: [
        { v: "Dringend", l: "Urgente" },
        { v: "In den nächsten Wochen", l: "Nelle prossime settimane" },
        { v: "In Planung", l: "In pianificazione" },
      ],
    },
  ],
};

export const questions = QUESTIONS.de; // backward-compat default
export const getQuestions = (lang = "de") => QUESTIONS[lang] || QUESTIONS.de;

const r = (primary, secondary, rationale) => ({ primary, secondary, rationale });

// Internal recommendation always returns canonical (German) Verfahren-keys
// so verfahrenLabels can resolve them per language. Rationale is provided per lang.
export function recommend({ material, goal, quantity }, lang = "de") {
  const series = quantity === "Großserie" || quantity === "Mittlere Serie";
  const RA = RATIONALE[lang] || RATIONALE.de;

  if (material === "Edelstahl") {
    if (goal === "Bessere Optik") return r("CNS-Elektropolieren", ["Schleifen · Bürsten"], RA.steel_optics);
    if (goal === "Korrosionsschutz") return r("CNS-Beizen", ["CNS-Elektropolieren"], RA.steel_corr);
    return r("CNS-Elektropolieren", ["CNS-Beizen"], RA.steel_default);
  }
  if (material === "Stahl") {
    if (goal === "Korrosionsschutz")
      return r(series ? "Trommelverzinken" : "Verzinken", ["Zink-Nickel"], series ? RA.iron_corr_series : RA.iron_corr_single);
    if (goal === "Verschleißschutz") return r("Zink-Mangan-Phosphatieren", ["Chemisch-Nickel"], RA.iron_wear);
    if (goal === "Bessere Optik") return r("Brünieren", ["Vergolden"], RA.iron_optics);
    if (goal === "Leitfähigkeit") return r("Galvanisch-Nickel", ["Vergolden"], RA.iron_cond);
    return r("Verzinken", ["Zink-Nickel", "Brünieren"], RA.iron_default);
  }
  if (material === "Aluminium") {
    if (goal === "Korrosionsschutz" || goal === "Verschleißschutz") return r("Chemisch-Nickel", ["Galvanisch-Nickel"], RA.alu_corr);
    if (goal === "Leitfähigkeit") return r("Vergolden", ["Galvanisch-Nickel"], RA.alu_cond);
    if (goal === "Bessere Optik") return r("Galvanisch-Nickel", ["Schleifen · Bürsten"], RA.alu_optics);
    return r("Chemisch-Nickel", [], RA.alu_default);
  }
  if (material === "Messing" || material === "Kupfer") {
    if (goal === "Bessere Optik" || goal === "Leitfähigkeit") return r("Vergolden", ["Galvanisch-Nickel"], RA.copper_gold);
    if (goal === "Korrosionsschutz") return r("Galvanisch-Nickel", ["Chemisch-Nickel"], RA.copper_nickel);
    return r("Vergolden", ["Galvanisch-Nickel"], RA.copper_default);
  }
  return r(lang === "en" ? "Personal consultation" : lang === "fr" ? "Consultation personnelle" : lang === "it" ? "Consulenza personale" : "Persönliche Beratung", [], RA.fallback);
}

const RATIONALE = {
  de: {
    steel_optics: "Für sichtbare Edelstahl-Bauteile liefert das CNS-Elektropolieren die hygienischste, glänzendste und korrosionsbeständigste Oberfläche. Mechanisch geschliffene Vorbereitung verstärkt das Ergebnis.",
    steel_corr: "CNS-Beizen entfernt Anlauffarben und Zunder vollständig — die Oberfläche wird passiv und korrosionsbeständig. Für höchste Anforderungen kombinieren wir mit Elektropolieren.",
    steel_default: "Für Edelstahl unter technischer Belastung empfehlen wir das Elektropolieren — reinraumtauglich, hygienisch, langlebig.",
    iron_corr_series: "Für mittlere und große Serien ist Trommelverzinken das wirtschaftlichste Verfahren mit gleichmäßiger Schichtdicke. Für besonders hohe Korrosionsanforderungen empfehlen wir zusätzlich Zink-Nickel.",
    iron_corr_single: "Klassisches Verzinken liefert robusten, langlebigen Korrosionsschutz für Einzelteile und kleine Stückzahlen. Für anspruchsvolle Umgebungen ist Zink-Nickel die Premiumlösung.",
    iron_wear: "Phosphatschichten verbessern Reibung und Verschleiß deutlich. Wo zusätzlich Härte und Maßhaltigkeit gefragt sind, liefert Chemisch-Nickel eine gleichmäßige, harte Schutzschicht.",
    iron_optics: "Brünieren erzeugt eine tiefschwarze, dezente Oberfläche bei minimalem Schichtauftrag. Für hochwertige Akzente ist galvanisches Vergolden eine repräsentative Alternative.",
    iron_cond: "Für leitfähige Funktionsoberflächen auf Stahl ist galvanisches Nickel der Standard. Für Kontaktstellen oder Hochfrequenzanwendungen ergänzen wir mit Goldveredelung.",
    iron_default: "Standard-Korrosionsschutz für Stahlbauteile — robust, wirtschaftlich und seit Jahrzehnten bewährt.",
    alu_corr: "Stromlose Vernicklung umhüllt Aluminium-Bauteile gleichmäßig — auch bei komplexen Geometrien. Hart, korrosionsbeständig, präzise.",
    alu_cond: "Für leitfähige Anschluss- und Kontaktflächen ist eine Goldschicht über galvanischem Nickel die zuverlässigste Lösung.",
    alu_optics: "Geschliffene und galvanisch vernickelte Aluminiumoberflächen wirken hochwertig und sind dauerhaft beständig.",
    alu_default: "Chemisch-Nickel ist auf Aluminium die universellste Veredelung — funktional und ästhetisch.",
    copper_gold: "Auf Buntmetallen erzielt galvanisches Vergolden sowohl ästhetisch als auch funktional (Leitfähigkeit, Anlaufschutz) ein hervorragendes Ergebnis.",
    copper_nickel: "Eine galvanische Nickelschicht schützt Buntmetalle zuverlässig vor Anlaufen und Korrosion.",
    copper_default: "Vergolden ist die klassische Veredelung für hochwertige Messing- und Kupferteile — repräsentativ und beständig.",
    fallback: "Für Ihren Werkstoff schlagen wir gerne eine maßgeschneiderte Kombination unserer 11 Verfahren vor. Schicken Sie uns Ihre Anforderungen — wir melden uns innerhalb eines Werktags.",
  },
  en: {
    steel_optics: "For visible stainless-steel parts, electropolishing delivers the most hygienic, brightest and most corrosion-resistant surface. A mechanically ground preparation enhances the result.",
    steel_corr: "Stainless-steel pickling fully removes heat tint and scale — the surface becomes passive and corrosion-resistant. For the highest requirements we combine it with electropolishing.",
    steel_default: "For stainless steel under technical load we recommend electropolishing — cleanroom-grade, hygienic, durable.",
    iron_corr_series: "For medium and high volumes, barrel zinc plating is the most economical process with uniform coating thickness. For particularly demanding corrosion requirements we also recommend zinc-nickel.",
    iron_corr_single: "Classic zinc plating provides robust, long-lasting corrosion protection for single parts and small quantities. For demanding environments, zinc-nickel is the premium solution.",
    iron_wear: "Phosphate layers significantly improve friction and wear behaviour. Where additional hardness and dimensional stability are required, electroless nickel delivers a uniform, hard protective layer.",
    iron_optics: "Black oxide creates a deep-black, subtle surface with minimal build-up. For premium accents, electrolytic gold plating is a representative alternative.",
    iron_cond: "For conductive functional surfaces on steel, electrolytic nickel is the standard. For contact areas or high-frequency applications we complement with gold plating.",
    iron_default: "Standard corrosion protection for steel parts — robust, economical and proven for decades.",
    alu_corr: "Electroless nickel deposits uniformly on aluminium parts — even on complex geometries. Hard, corrosion-resistant, precise.",
    alu_cond: "For conductive terminals and contact surfaces, a gold layer over electrolytic nickel is the most reliable solution.",
    alu_optics: "Ground and nickel-plated aluminium surfaces look premium and remain durable.",
    alu_default: "Electroless nickel is the most universal finish on aluminium — functional and aesthetic.",
    copper_gold: "On non-ferrous metals, electrolytic gold plating delivers an outstanding result both aesthetically and functionally (conductivity, tarnish protection).",
    copper_nickel: "An electrolytic nickel layer reliably protects non-ferrous metals from tarnishing and corrosion.",
    copper_default: "Gold plating is the classic finish for premium brass and copper parts — representative and lasting.",
    fallback: "For your material we'd be glad to propose a tailored combination of our 11 processes. Send us your requirements — we'll respond within one business day.",
  },
  fr: {
    steel_optics: "Pour les pièces inox visibles, le polissage électrolytique offre la surface la plus hygiénique, la plus brillante et la plus résistante à la corrosion. Une préparation mécanique brossée renforce le résultat.",
    steel_corr: "Le décapage inox élimine totalement les colorations thermiques et la calamine — la surface devient passive et résistante à la corrosion. Pour les exigences les plus élevées, nous combinons avec le polissage électrolytique.",
    steel_default: "Pour de l'inox sous contrainte technique, nous recommandons le polissage électrolytique — compatible salle blanche, hygiénique, durable.",
    iron_corr_series: "Pour les séries moyennes et grandes, le zingage au tonneau est le procédé le plus économique avec une épaisseur uniforme. Pour des exigences de corrosion particulièrement élevées, nous recommandons en complément le zinc-nickel.",
    iron_corr_single: "Le zingage classique offre une protection anti-corrosion robuste et durable pour pièces unitaires et petites séries. Pour environnements exigeants, le zinc-nickel est la solution premium.",
    iron_wear: "Les couches de phosphate améliorent significativement le frottement et l'usure. Là où la dureté et la stabilité dimensionnelle sont requises, le nickelage chimique fournit une couche dure et uniforme.",
    iron_optics: "Le brunissage crée une surface noir profond, discrète, avec un dépôt minimal. Pour des accents haut de gamme, la dorure électrolytique est une alternative représentative.",
    iron_cond: "Pour les surfaces fonctionnelles conductrices sur acier, le nickelage électrolytique est le standard. Pour les zones de contact ou les applications HF, nous complétons par une dorure.",
    iron_default: "Protection anti-corrosion standard pour pièces acier — robuste, économique et éprouvée depuis des décennies.",
    alu_corr: "Le nickelage chimique se dépose uniformément sur l'aluminium — même sur géométries complexes. Dur, anti-corrosion, précis.",
    alu_cond: "Pour bornes et surfaces de contact conductrices, une couche d'or sur nickel électrolytique est la solution la plus fiable.",
    alu_optics: "Les surfaces aluminium brossées et nickelées rendent un aspect haut de gamme et restent durables.",
    alu_default: "Le nickelage chimique est la finition la plus universelle sur aluminium — fonctionnelle et esthétique.",
    copper_gold: "Sur les métaux non ferreux, la dorure électrolytique offre un résultat exceptionnel à la fois esthétique et fonctionnel (conductivité, anti-ternissement).",
    copper_nickel: "Une couche de nickel électrolytique protège fiablement les métaux non ferreux du ternissement et de la corrosion.",
    copper_default: "La dorure est la finition classique pour pièces haut de gamme en laiton et cuivre — représentative et durable.",
    fallback: "Pour votre matériau, nous proposons volontiers une combinaison sur mesure parmi nos 11 procédés. Envoyez-nous vos exigences — nous vous répondons sous un jour ouvré.",
  },
  it: {
    steel_optics: "Per i componenti inox a vista, l'elettrolucidatura offre la superficie più igienica, brillante e resistente alla corrosione. Una preparazione meccanica di levigatura ne esalta il risultato.",
    steel_corr: "Il decapaggio inox rimuove completamente ossidazioni e calamine — la superficie diventa passiva e resistente alla corrosione. Per le esigenze più elevate combiniamo con l'elettrolucidatura.",
    steel_default: "Per inox sotto carico tecnico raccomandiamo l'elettrolucidatura — idonea camera bianca, igienica, duratura.",
    iron_corr_series: "Per medie e grandi serie la zincatura a rotobarile è il procedimento più economico, con spessori uniformi. Per esigenze anticorrosive elevate consigliamo in aggiunta lo zinco-nichel.",
    iron_corr_single: "La zincatura classica offre una protezione anticorrosiva robusta e duratura per pezzi singoli e piccole quantità. Per ambienti severi lo zinco-nichel è la soluzione premium.",
    iron_wear: "Gli strati di fosfato migliorano nettamente attrito e usura. Dove servono ulteriore durezza e stabilità dimensionale, il nichel chimico fornisce uno strato uniforme e duro.",
    iron_optics: "La brunitura crea una superficie nera profonda, discreta, con deposito minimo. Per accenti di pregio, la doratura galvanica è un'alternativa rappresentativa.",
    iron_cond: "Per superfici funzionali conduttive su acciaio, il nichel galvanico è lo standard. Per zone di contatto o applicazioni RF integriamo con doratura.",
    iron_default: "Protezione anticorrosiva standard per componenti in acciaio — robusta, economica e collaudata da decenni.",
    alu_corr: "Il nichel chimico riveste l'alluminio in modo uniforme — anche su geometrie complesse. Duro, anticorrosivo, preciso.",
    alu_cond: "Per terminali e superfici di contatto conduttive, una doratura sopra nichel galvanico è la soluzione più affidabile.",
    alu_optics: "Le superfici in alluminio levigate e nichelate appaiono pregiate e mantengono nel tempo le qualità.",
    alu_default: "Il nichel chimico è la finitura più universale sull'alluminio — funzionale ed estetica.",
    copper_gold: "Sui metalli non ferrosi, la doratura galvanica offre un risultato eccellente sia estetico che funzionale (conduttività, anti-ossidazione).",
    copper_nickel: "Uno strato di nichel galvanico protegge in modo affidabile i metalli non ferrosi da ossidazione e corrosione.",
    copper_default: "La doratura è la finitura classica per parti pregiate in ottone e rame — rappresentativa e duratura.",
    fallback: "Per il Suo materiale proponiamo volentieri una combinazione su misura tra i nostri 11 procedimenti. Ci invii le Sue esigenze — risponderemo entro un giorno lavorativo.",
  },
};
